import React from "react";
import { PackageSearch } from "lucide-react";

import { Button } from "../ui/button";

export function EmptyState({
  icon: Icon = PackageSearch,
  title,
  body,
  actionLabel,
  onAction,
  testId = "empty-state",
}) {
  return (
    <div
      className="flex min-h-[280px] flex-col items-center justify-center rounded-lg border border-dashed border-border-subtle bg-surface/60 px-6 py-12 text-center"
      data-testid={testId}
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-offwhite">
        <Icon className="h-5 w-5 text-taupe" />
      </div>
      <h3 className="text-base font-semibold text-text-primary">{title}</h3>
      {body && (
        <p className="mt-2 max-w-sm text-sm text-text-secondary">{body}</p>
      )}
      {actionLabel && onAction && (
        <Button
          variant="ghost"
          onClick={onAction}
          data-testid={`${testId}-action`}
          className="mt-4 text-taupe hover:bg-offwhite hover:text-charcoal"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
